// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2165":"f097b7bc0e7f8f4f","5562":"7e4be8ebf1de46e1"}[chunkId] + ".css";
};